import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.local_configurations;


// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper for this namespace/group
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'management_api',
  group: 'local_configurations',
  defaultTtl: '15m',
  hashLargeSegments: true,
  emitMeta: true,
});

// getLocalConfigurationsByLocalId

export const getLocalConfigurationByLocalId = async (localId: number) => {
  return await cachedApi.get(`/GetLocalConfigurationByLocalId/${localId}`);
}

// Function to update a mesa
export const updateLocalConfigurationByLocalId = async (localConfigId: number, localConfigData: any) => {
  const res = await api.put(`/UpdateLocalConfigurationByLocalId/${localConfigId}`, localConfigData, {});
  await cachedApi.clear();
  return res;
};


export const setLocalLogoByLocalId = async (localId: number, logo: string) => {
  const res = await api.post(`/SetLocalLogoByLocalId/${localId}`, { "logo": logo }, {});
  await cachedApi.clear();
  return res;
};

// /RemoveLocalLogoByLocalId/<int:local_id>

export const removeLocalLogoByLocalId = async (localId: number) => {
  const res = await api.delete(`/RemoveLocalLogoByLocalId/${localId}`, {});
  await cachedApi.clear();
  return res;
};

// Function to update the local configuration auto accept orders setting

export const toggleAutoAcceptOrdersByLocalId = async (localId: number) => {
  const res = await api.put(`/ToggleAutoAcceptOrdersByLocalId/${localId}`, {});
  await cachedApi.clear();
  return res;
}